<div class="p-(--padding-card)">
  <ces-route-title [count]="users().length" />

  <ces-generic-parent-grid [dataLoadingCompleted]="dataLoadingCompleted" [entities]="users()" [entityDefinition]="userDefinition()" />
</div>
